import { render, staticRenderFns } from "./crearConjuntos.vue?vue&type=template&id=8a510150"
import script from "./crearConjuntos.vue?vue&type=script&lang=js"
export * from "./crearConjuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports